let appMessageApi: any;
let appNotificationApi: any;

const noop = () => undefined;

const noopMessageApi = {
  success: noop,
  error: noop,
  warning: noop,
  info: noop,
  loading: noop,
  open: noop,
  destroy: noop,
};

const noopNotificationApi = {
  success: noop,
  error: noop,
  warning: noop,
  info: noop,
  open: noop,
  destroy: noop,
};

export const setAntdAppApis = (messageApi: any, notificationApi: any) => {
  appMessageApi = messageApi;
  appNotificationApi = notificationApi;
};

export const getMessageApi = () => appMessageApi || noopMessageApi;

export const getNotificationApi = () => appNotificationApi || noopNotificationApi;
